module.exports = __webpack_public_path__ + "img/title.7b46e7c9.png";